import { TermsService } from 'core/api/services/terms';
import React, { useContext, useState } from 'react';

const TermsContext = React.createContext(null);

export const TermsProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);
    const [experiencesTerms, setExperiencesTerms] = useState([]);
    const [activeTerms, setActiveTerms] = useState(null);

     const getExperiencesTerms = async (experienceId) => {
        try {
            setLoading(true);
            const result = await TermsService.getExperiencesTerms(experienceId);
            if (result) {
                setExperiencesTerms(result?.experienceTerms);
                setActiveTerms(result?.activeTerms);
            } else {
                setExperiencesTerms([]);
                setActiveTerms(null);
            }

            return result;
        } catch (error) {
            console.error(error);
            setExperiencesTerms([]);
            setActiveTerms(null);
            return false;
        } finally {
            setLoading(false);
        }
    };

    return (
        <TermsContext.Provider
            value={{
                loading,
                experiencesTerms,
                activeTerms,
                getExperiencesTerms,
            }}>
            {children}
        </TermsContext.Provider>
    );
};

TermsProvider.displayName = 'TermsProvider';

export const useTerms = () => useContext(TermsContext);
